
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateOpportunityTestFixtureRequest,
  RepatriationOpportunityTestFixturesResource,
} from '../models';
import {
    CreateOpportunityTestFixtureRequestFromJSON,
    CreateOpportunityTestFixtureRequestToJSON,
    RepatriationOpportunityTestFixturesResourceFromJSON,
    RepatriationOpportunityTestFixturesResourceToJSON,
} from '../models';

export interface CreateFixtureRepatriationOpportunityGroupRequest {
    createOpportunityTestFixtureRequest: CreateOpportunityTestFixtureRequest;
}

/**
 * 
 */
export class RepatriationOpportunityAcceptanceTestFixturesApi extends runtime.BaseAPI {

    /**
     * Create a repatriation opportunity to be used in the test fixtures
          */
    async createFixtureRepatriationOpportunityGroupRaw(requestParameters: CreateFixtureRepatriationOpportunityGroupRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityTestFixturesResource>> {
        if (requestParameters['createOpportunityTestFixtureRequest'] == null) {
            throw new runtime.RequiredError(
                'createOpportunityTestFixtureRequest',
                'Required parameter "createOpportunityTestFixtureRequest" was null or undefined when calling createFixtureRepatriationOpportunityGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<RepatriationOpportunityTestFixturesResource>({
            path: `/repatriation-opportunity/api/test-fixtures/repatriation-opportunity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOpportunityTestFixtureRequestToJSON(requestParameters['createOpportunityTestFixtureRequest']),
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityTestFixturesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a repatriation opportunity to be used in the test fixtures
          */
    async createFixtureRepatriationOpportunityGroup(requestParameters: CreateFixtureRepatriationOpportunityGroupRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityTestFixturesResource> {
        const response = await this.createFixtureRepatriationOpportunityGroupRaw(requestParameters, initOverrides);
        return response._data;
    }

}
